import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import { categoryService } from "services/category.service";
import authStore from "stores/auth/AuthStore";
import { Category } from "types/category.type";

class CategoryStore {
  categories: Category[] = [];
  selectedCategory: Category | null = null;
  loadingFetch = false;
  loadingAction = false;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchCategories() {
    if (!authStore.isAuthenticated()) return;

    this.loadingFetch = true;
    try {
      const data = await categoryService.getAll();
      runInAction(() => {
        this.categories = data;
      });
    } catch (error: any) {
      if (
        error?.response?.data?.type === "role_changed" ||
        error?.response?.data?.type === "account_inactive"
      ) {
        return;
      }
      toast.error("Erreur lors du chargement des catégories");
    } finally {
      runInAction(() => {
        this.loadingFetch = false;
      });
    }
  }

  setSelected(category: Category | null) {
    this.selectedCategory = category;
  }

  async saveCategory(category: Partial<Category>) {
    this.loadingAction = true;
    try {
      if (category.id) {
        const response = await categoryService.update(category.id, category);
        const updated: Category = response.data;

        runInAction(() => {
          const index = this.categories.findIndex((c) => c.id === category.id);
          if (index !== -1) this.categories[index] = updated;
        });

        toast.success("Catégorie mise à jour !");
      } else {
        const response = await categoryService.create(category);
        const created: Category = response.data;

        runInAction(() => {
          this.categories.unshift(created);
        });
        toast.success("Catégorie créée !");
      }

      this.setSelected(null);
    } catch (error) {
      toast.error("Erreur lors de l'enregistrement");
      // throw error;
    } finally {
      runInAction(() => {
        this.loadingAction = false;
      });
    }
  }

  async deleteCategory(id: number) {
    this.loadingAction = true;
    try {
      await categoryService.delete(id);
      runInAction(() => {
        this.categories = this.categories.filter((c) => c.id !== id);
      });
      toast.success("Catégorie supprimée !");
    } catch (error) {
      toast.error("Erreur lors de la suppression");
    } finally {
      runInAction(() => {
        this.loadingAction = false;
      });
    }
  }
}

const categoryStore = new CategoryStore();
export default categoryStore;
